module.exports = __webpack_public_path__ + "img/Card_spade_A.f8944989.svg";